/**
 * Build a CSV string from an array of row objects using a column definition.
 *
 * @param {Array<{header: string, key: string, format?: (val, row) => string}>} columns
 * @param {Array<object>} rows
 * @returns {string}
 */
function buildCsv(columns, rows) {
  const escape = (v) => {
    const s = v == null ? '' : String(v);
    return s.includes(',') || s.includes('"') || s.includes('\n')
      ? `"${s.replace(/"/g, '""')}"`
      : s;
  };
  const header = columns.map((c) => escape(c.header)).join(',');
  const body = rows.map((row) =>
    columns.map((c) => escape(c.format ? c.format(row[c.key], row) : row[c.key])).join(',')
  );
  return [header, ...body].join('\r\n');
}

/**
 * Trigger a browser download of a CSV file.
 *
 * @param {string} csv  - CSV string
 * @param {string} filename - e.g. "domains-report-2026-04-15.csv"
 */
function downloadCsv(csv, filename) {
  const blob = new Blob([csv], { type: 'text/csv;charset=utf-8;' });
  const url = URL.createObjectURL(blob);
  const a = document.createElement('a');
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  document.body.removeChild(a);
  URL.revokeObjectURL(url);
}

/**
 * One-shot helper: build and immediately download a CSV.
 */
export function exportCsv(columns, rows, filename) {
  downloadCsv(buildCsv(columns, rows), filename);
}
